import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ToolbarWrapper } from './styled/ToolbarWrapper';
import { getRender } from '../../../../model/getAvailableRenderers';
import {
  getCrossWindowActiveViewport,
  getCrossWindowWindowId,
} from '../../Viewer/crossWindow2dReferenceLines';

export const Toolbar = (props) => {
  const layout = useSelector((state) => state.layout);
  const config = useSelector((state) => state.config);
  const [activeViewport, setActiveViewport] = useState(getCrossWindowActiveViewport());

  useEffect(() => {
    const updateActiveViewport = (event) => setActiveViewport(event.detail || null);
    window.addEventListener('viewer-active-viewport-changed', updateActiveViewport);
    return () => window.removeEventListener('viewer-active-viewport-changed', updateActiveViewport);
  }, []);

  const isRemoteViewportActive = activeViewport
    && activeViewport.windowId !== getCrossWindowWindowId();
  const localLayoutElement = layout.elements[layout.selectedViewIndex] || {};
  const currentLayoutElement = isRemoteViewportActive
    ? {
      renderType: activeViewport.renderType,
      availableRenderers: activeViewport.availableRenderers || [],
    }
    : localLayoutElement;
  const renderType = props.fetchComplete ? currentLayoutElement.renderType : undefined;
  const toolbarLayout = isRemoteViewportActive
    ? {
      ...layout,
      currentTool: activeViewport.currentTool || layout.currentTool,
      isMPRModeEnabled: activeViewport.mode === 'mpr',
      is3DModeEnabled: activeViewport.mode === '3d',
      activeViewportContext: activeViewport,
    }
    : layout;
  const { ToolbarRender } = getRender(renderType);

  return (
    <ToolbarWrapper>
      <ToolbarRender layout={toolbarLayout} config={config} currentLayoutElement={currentLayoutElement} />
    </ToolbarWrapper>
  );
};

export default Toolbar;
